export default __webpack_public_path__ + "static/media/trickortreat_awwman.25f73f7d.mp3";